// extracted by mini-css-extract-plugin
module.exports = {"icon":"Spinner_icon__CIv_I","spinner":"Spinner_spinner__2EHO4","spin":"Spinner_spin__1ybDd"};